import { Enums } from "./enums";

export const DEFAULT_API_REGION_SLUG = Enums.ApiGatewayRegionSlug.UsWest;

let apiRegionSlug: Enums.ApiGatewayRegionSlug = DEFAULT_API_REGION_SLUG;

function normalizeRegionSlug(
  slug: Enums.ApiGatewayRegionSlug,
): Enums.ApiGatewayRegionSlug {
  return slug === Enums.ApiGatewayRegionSlug.Australia
    ? Enums.ApiGatewayRegionSlug.Australia
    : DEFAULT_API_REGION_SLUG;
}

export function resetApiRegionSlug(): void {
  apiRegionSlug = DEFAULT_API_REGION_SLUG;
}

/** Magic-link verify `region` query param (`aue`, `usw`, or KV claim `2` / `1`). */
export function parseApiGatewayRegionSlugFromQuery(
  value: string | null | undefined,
): Enums.ApiGatewayRegionSlug {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (
    normalized === Enums.ApiGatewayRegionSlug.Australia ||
    normalized === Enums.ApiGatewayRegionClaim.Australia
  ) {
    return Enums.ApiGatewayRegionSlug.Australia;
  }
  return DEFAULT_API_REGION_SLUG;
}

export function setApiRegionSlug(slug: Enums.ApiGatewayRegionSlug): void {
  apiRegionSlug = normalizeRegionSlug(slug);
}

export function getApiRegionSlug(): Enums.ApiGatewayRegionSlug {
  return apiRegionSlug;
}
